import { RouteLocationRaw } from 'vue-router'
import useSystemStore from '~~/store/system'

export default defineNuxtPlugin((nuxtApp: any) => {
  /**
   *
   * @param {number} step 回退几步
   */
  nuxtApp.$router.backAnimation = (step: number) => {
    const router = useRouter()
    const systemStore = useSystemStore()
    systemStore.SET_TRANSITION('backward')
    if (step) {
      router.go(step)
    } else {
      router.back()
    }
  }

  /**
   *
   * @param {RouteLocationRaw} to 同 router.push()
   */
  nuxtApp.$router.pushAnimation = (to: RouteLocationRaw) => {
    const router = useRouter()
    const systemStore = useSystemStore()
    systemStore.SET_TRANSITION('forward')
    router.push(to)
  }
})
